import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import { Icon } from "@common/Icon/Icon";

export const EmailVerificationSuccess = () => {
    const { t } = useTranslation(["glossary", "forgotEmail"]);

    return (
        <Grid alignItems="center" container direction="column" spacing={2}>
            <Grid item>
                <Typography>
                    <Icon className="icon-light-grey" name="paper-plane" size="large" />
                </Typography>
            </Grid>
            <Grid item>
                <Typography align="center" color="secondary">
                    {t("glossary:thankYou")}!
                </Typography>
            </Grid>
            <Grid item>
                <Typography align="center" color="secondary">
                    {t("forgotEmail:emailSuccess")}
                    <br />
                    {t("forgotEmail:emailSuccess2")}
                </Typography>
            </Grid>
        </Grid>
    );
};
